// Material Symbols match for the original `sidebar/teams` glyph (Material
// Icons `group_work`): three dots on the team color once drawn in a badge.
export const DEFAULT_TEAM_ICON = 'workspaces';

export function teamBadgeIcon(team) {
  return team?.icon || DEFAULT_TEAM_ICON;
}
